import { useLocaleState } from "ra-core";
import { DataTable } from "@/components/admin/data-table";
import { ReferenceField } from "@/components/admin/reference-field";

import { ChoiceBadge } from "../misc/ChoiceBadge";
import { RatingStars } from "../misc/Rating";
import { formatLocalizedDate } from "../misc/RelativeDate";
import { ToDefine } from "../misc/ToDefine";
import { useConfigurationContext } from "../root/ConfigurationContext";
import type { Company } from "../types";
import { CompanyAvatar } from "./CompanyAvatar";

/** Prospect list: one row per company, sortable, click to open the record. */
export const CompanyTable = () => {
  const { customerStatuses, prospectStates } = useConfigurationContext();
  const [locale = "fr"] = useLocaleState();

  return (
    <DataTable<Company> rowClick="show" bulkActionButtons={false}>
      <DataTable.Col
        source="name"
        render={(record) => (
          <span className="flex items-center gap-2 font-medium">
            <CompanyAvatar record={record as Company} width={20} height={20} />
            {record.name}
          </span>
        )}
      />
      <DataTable.Col
        source="customer_status"
        disableSort
        render={(record) => (
          <ChoiceBadge
            choices={customerStatuses}
            value={record.customer_status}
          />
        )}
      />
      <DataTable.Col
        source="prospect_state"
        disableSort
        render={(record) => (
          <ChoiceBadge choices={prospectStates} value={record.prospect_state} />
        )}
      />
      <DataTable.Col
        source="lead_score"
        sortByOrder="DESC"
        render={(record) => <RatingStars value={record.lead_score} />}
      />
      <DataTable.Col source="sales_id" disableSort>
        <ReferenceField
          source="sales_id"
          reference="sales"
          link={false}
          empty={<ToDefine />}
        />
      </DataTable.Col>
      <DataTable.Col
        source="last_contact_date"
        sortByOrder="DESC"
        render={(record) =>
          record.last_contact_date ? (
            formatLocalizedDate(record.last_contact_date, locale)
          ) : (
            <ToDefine />
          )
        }
      />
      <DataTable.Col source="city" />
      <DataTable.NumberCol source="nb_contacts" />
    </DataTable>
  );
};
